import { FC } from 'react'
import { Layout } from 'components/Layout'
import { StockTemplate } from 'components/Templates'

const Stock: FC = () => {
  return (
    <Layout headline={'在庫の増減と通知'} iconPath={'/icon/white/stock.svg'} title={'在庫の増減と通知'}>
      <StockTemplate />
    </Layout>
  )
}

export default Stock
